import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card'
import BillingPortalButton from '~/pages/backoffice/admin/billing/BillingPortalButton'

/**
 * À la place du formulaire de coordonnées une fois le client Stripe créé (#353) :
 * adresse, n° de TVA et e-mail de facturation vivent alors chez Stripe, qui les
 * reprend sur les factures. Deux endroits pour les mêmes données divergeraient.
 */
function BillingPortalNotice() {
  const { t } = useTranslation()

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('billing.profile.title')}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-muted-foreground">{t('billing.portal.profile')}</p>
        <BillingPortalButton variant="outline">{t('billing.portal.invoices')}</BillingPortalButton>
      </CardContent>
    </Card>
  )
}

export default BillingPortalNotice
